import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@models/form/button';
import { Clipboard } from '@angular/cdk/clipboard';

export interface ILinkDialog {
  link: string;
  message: string;
}

@Component({
  templateUrl: './copy-link-dialog.component.html',
  styleUrls: ['./copy-link-dialog.component.scss'],
})
export class CopyLinkDialog implements OnInit {
  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Copy Link',
    showCancel: false,
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ILinkDialog,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private clipboard: Clipboard,
  ) {}

  ngOnInit(): void {}

  public submit(): void {
    const result = this.clipboard.copy(this.data.link);
    this.dialogRef.close(result);
  }
}
